import { JSX } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import type { InterviewState } from 'src/redux/slices/Interview/types';

export default function ErrorScreen(): JSX.Element {
  const navigate = useNavigate();
  const errorMessage = useSelector(
    (state: { interview: InterviewState }) => state.interview.errorMessage
  );

  const handleGoHome = (): void => {
    navigate('/renter');
  };

  return (
    <Box
      data-testid="error-screen"
      sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          p: 4,
          flex: 1,
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: 'error.light',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 40, color: 'error.dark' }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          Something went wrong
        </Typography>
        {errorMessage && (
          <Typography
            sx={{ color: 'text.secondary', mb: 4 }}
            data-testid="error-message"
          >
            {errorMessage}
          </Typography>
        )}
      </Box>
      <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleGoHome}
          data-testid="go-home-button"
        >
          Go to home page
        </Button>
      </Box>
    </Box>
  );
}
